import React from "react";
import banner from "../Image/PS.png";
import banner1 from "../Image/car rental.png";
import banner2 from "../Image/Voit.png";
import banner3 from "../Image/Resturant.png";
import banner4 from "../Image/Beauty.png";
import banner44 from "../Image/Fitness.png";
import banner5 from "../Image/Travel (2).png";
import banner55 from "../Image/Travel (1).png";
import banner51 from "../Image/CRM.png";

function OurWork() {
  const projects = [
    { img: banner, title: "Health Care App" },
    { img: banner1, title: "Car Rental App" },
    { img: banner2, title: "E-commerce App" },
    { img: banner3, title: "ND Connect App" },
    { img: banner44, title: "PMS® ERP for FMCG Wholesale App" },
    { img: banner5, title: "Grocery App" },
    { img: banner4, title: "Municipal Corporation Software App" },
    { img: banner55, title: "TimeShare Management Solution" },
    { img: banner51, title: "CRM App" },
  ];

  return (
    <section className="portfolio-section pad-tb">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="common-heading">
              <span>Our Work</span>
              <h2 className="mb20">Our Latest Creative Work</h2>
            </div>
          </div>
        </div>

        <div className="row">
          {projects.map((project, index) => (
            <div
              key={index}
              className="col-lg-4 col-sm-6 mt40 wow fadeIn"
              data-wow-delay={`${0.2 * (index + 1)}s`}
            >
              <div className="isotope_item up-hor">
                <div className="item-image">
                  <img src={project.img} alt={project.title} className="img-fluid" />
                </div>
                <div className="item-info-div shdo" style={{ textAlign: "center", marginTop: "10px" }}>
                  <h4>{project.title}</h4>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default OurWork;
